import { type MeResponseDto } from '../../../api/common-api.ts';
import { type Nullable } from '../../../api/types.ts';
import { type RedirectsContextType } from '../../helpers/hooks/index.ts';
import { createContextProvider, createDataContext } from '../utils';

export const LoaderContext = createDataContext<boolean>();
export const LoaderContextProvider = createContextProvider<boolean>(LoaderContext);
LoaderContext.displayName = 'LoaderContext';

export const AuthContext = createDataContext<Nullable<MeResponseDto>>();
export const AuthContextProvider = createContextProvider<Nullable<MeResponseDto>>(AuthContext);
AuthContext.displayName = 'AuthContext';

export const RedirectsContext = createDataContext<RedirectsContextType>();
export const RedirectsProvider = createContextProvider<RedirectsContextType>(RedirectsContext);
AuthContext.displayName = 'RedirectsContext';
